import { EventEmitter, Injectable, Output } from '@angular/core';
import { Brand } from '../../shared/models/brand/brand.model';
import { Channel } from '../../shared/models/channel/channel.model';
import { Lead } from '../../shared/models/lead/lead';
import { LeadFilter } from '../../shared/models/lead/leadFilter';
import { UnAssignLeadsInput } from '../../shared/models/lead/unAssignLeads.input';
import { RolType } from '../../shared/models/types/rol.types';
import { AuthService } from '../../shared/services/security/auth.service';
import { AssignmentRuleFilters } from '../profile/assignmentRuleFilters';
import { Dealer } from './../../shared/models/dealer/dealer.model';
import { LeadConcurrence } from './../../shared/models/lead/leadConcurrence';
import { LeadPotentialSellerCount } from './../../shared/models/lead/leadPotentialSellerCount';
import { User } from './../../shared/models/user/user.model';

@Injectable()
export class LeadsComunicationService {

  @Output() readonly filter: EventEmitter<LeadFilter> = new EventEmitter();
  @Output() readonly customFilter: EventEmitter<boolean> = new EventEmitter();
  @Output() readonly assignmentRulesFilter: EventEmitter<AssignmentRuleFilters> = new EventEmitter();
  @Output() readonly reloadLeads: EventEmitter<any> = new EventEmitter();
  @Output() readonly reloadMyLead: EventEmitter<any> = new EventEmitter();
  @Output() readonly showData: EventEmitter<boolean> = new EventEmitter();
  @Output() readonly refreshLeadsList: EventEmitter<void> = new EventEmitter();
  @Output() readonly refresHistoric: EventEmitter<void> = new EventEmitter();
  @Output() readonly refreshMetrics: EventEmitter<string> = new EventEmitter();
  @Output() readonly refreshClosingRatio: EventEmitter<any> = new EventEmitter();
  @Output() readonly paintConcurrence: EventEmitter<LeadConcurrence[]> = new EventEmitter();
  @Output() readonly disabledConcurrence: EventEmitter<boolean> = new EventEmitter();
  @Output() readonly paintPotentialSellers: EventEmitter<LeadPotentialSellerCount[]> = new EventEmitter();
  @Output() readonly disablePotentialSellers: EventEmitter<boolean> = new EventEmitter();
  @Output() readonly concurrenceGetted: EventEmitter<number> = new EventEmitter();
  @Output() readonly leadGetted: EventEmitter<Lead> = new EventEmitter();
  @Output() readonly changedBetweenViews: EventEmitter<void> = new EventEmitter();
  @Output() readonly sendEmailInvitation: EventEmitter<void> = new EventEmitter();
  @Output() readonly sendWhatsappInvitation: EventEmitter<void> = new EventEmitter();
  @Output() readonly invitationSended: EventEmitter<void> = new EventEmitter();
  @Output() readonly goToLead: EventEmitter<void> = new EventEmitter();
  @Output() readonly unAssignLead: EventEmitter<UnAssignLeadsInput> = new EventEmitter();
  @Output() readonly toggleViewRequested: EventEmitter<void> = new EventEmitter();
  @Output() readonly createLeadRequested: EventEmitter<void> = new EventEmitter();
  @Output() readonly downloadLeadsRequested: EventEmitter<void> = new EventEmitter();
  @Output() readonly leadsOrderRequested: EventEmitter<{ orderField: string; orderBy: string }> = new EventEmitter();

  @Output() cleanPagination: EventEmitter<void> = new EventEmitter();
  @Output() readonly paintClosestEvents: EventEmitter<any> = new EventEmitter();
  private _brands: Brand[] = [];
  private _channels: Channel[] = [];
  private _users: User[];
  private _dealers: Dealer[];
  rolType: RolType = new RolType();

  public constructor(private readonly authService: AuthService) {
  }

  applyAssignmentRulesFilter(filter: AssignmentRuleFilters): void {
    this.assignmentRulesFilter.emit(filter);
  }

  applyFilter(filter: LeadFilter): void {
    this.filter.emit(filter);
  }

  applyCustomFilter(applied: boolean): void {
    this.customFilter.emit(applied);
  }

  launchReloadLeads(refreshOrigin?: boolean): void {
    this.reloadLeads.emit(refreshOrigin);
  }

  launchReloadMyLead(leadId?: string, companyId?: string): void {
    this.reloadMyLead.emit({ leadId, companyId });
  }

  launchShowDataBdc(showData: boolean): void {
    this.showData.emit(showData);
  }

  set brands(brands: Brand[]) {
    this._brands = brands;
  }

  get brands() {
    return this._brands;
  }

  set channels(channels: Channel[]) {
    this._channels = channels;
  }

  get channels() {
    return this._channels;
  }

  set users(users: User[]) {
    this._users = users;
  }

  get users() {
    return this._users;
  }
  set dealers(dealers: Dealer[]) {
    this._dealers = dealers;
  }

  get dealers() {
    return this._dealers;
  }

  requestToggleView(): void {
    this.toggleViewRequested.emit();
  }

  requestCreateLead(): void {
    this.createLeadRequested.emit();
  }

  requestDownloadLeads(): void {
    this.downloadLeadsRequested.emit();
  }

  requestLeadsOrder(orderField: string, orderBy: string): void {
    this.leadsOrderRequested.emit({ orderField, orderBy });
  }

}
